// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.components-container[data-v-9f197a6c] {\n  position: relative;\n  height: 100vh;\n}\n.left-container[data-v-9f197a6c] {\n  background-color: #F38181;\n  height: 100%;\n}\n.right-container[data-v-9f197a6c] {\n  background-color: #FCE38A;\n  height: 200px;\n}\n.top-container[data-v-9f197a6c] {\n  background-color: #FCE38A;\n  width: 100%;\n  height: 100%;\n}\n.bottom-container[data-v-9f197a6c] {\n  width: 100%;\n  background-color: #95E1D3;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
